var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { "align-v": "end", offset: "0", "offset-lg": "6" } },
            [
              _c("b-form-input", {
                attrs: {
                  placeholder: _vm.$t(
                    "apeironGwApp.matriculaGpln.acciones.buscar"
                  ),
                },
                on: {
                  keyup: function ($event) {
                    return _vm.buscarEnAlumnos()
                  },
                },
                model: {
                  value: _vm.filtroAlumnos,
                  callback: function ($$v) {
                    _vm.filtroAlumnos = $$v
                  },
                  expression: "filtroAlumnos",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  bordered: "",
                  small: "",
                  "thead-class": "custom-header",
                  items: _vm.alumnosFiltrados,
                  fields: _vm.fieldsAlumnos,
                  "show-empty": "",
                  "empty-text": _vm.$t(
                    "apeironGwApp.matriculaGpln.tabla.sinRegistros"
                  ),
                  "per-page": _vm.perPage,
                  "current-page": _vm.currentPage,
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(participante)",
                    fn: function (data) {
                      return [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(data.item.participante?.nombre),
                          },
                        }),
                        _vm._v(" "),
                        _c("span"),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              data.item.participante?.apellidoPaterno
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("span"),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              data.item.participante?.apellidoMaterno
                            ),
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "cell(tiempoDedicacion)",
                    fn: function (data) {
                      return [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.decodeTiempoParticipacion(
                                data.item.participante.tiempoDedicacion
                              )
                            ),
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "cell(acciones)",
                    fn: function (data) {
                      return [
                        _c(
                          "div",
                          { staticClass: "btn-group" },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.top",
                                    value: _vm.$t(
                                      "apeironGwApp.matriculaGpln.acciones.ver"
                                    ),
                                    expression:
                                      "$t('apeironGwApp.matriculaGpln.acciones.ver')",
                                    modifiers: { hover: true, top: true },
                                  },
                                ],
                                attrs: { size: "sm", variant: "outline" },
                                on: {
                                  click: function ($event) {
                                    return _vm.mostrarModalDetalleAlumno(
                                      data.item
                                    )
                                  },
                                },
                              },
                              [
                                _c("b-icon", {
                                  attrs: {
                                    icon: "exclamation-lg",
                                    variant: "primary",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.top",
                                    value: _vm.$t(
                                      "apeironGwApp.matriculaGpln.acciones.editar"
                                    ),
                                    expression:
                                      "$t('apeironGwApp.matriculaGpln.acciones.editar')",
                                    modifiers: { hover: true, top: true },
                                  },
                                ],
                                attrs: {
                                  size: "sm",
                                  variant: "outline",
                                  disabled: _vm.readOnly,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.editarAlumno(data.item)
                                  },
                                },
                              },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "pencil", variant: "primary" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.top",
                                    value: _vm.$t(
                                      "apeironGwApp.matriculaGpln.acciones.eliminar"
                                    ),
                                    expression:
                                      "$t('apeironGwApp.matriculaGpln.acciones.eliminar')",
                                    modifiers: { hover: true, top: true },
                                  },
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      data.item.participante
                                        .estadoSolicitudBeca == null,
                                    expression:
                                      "data.item.participante.estadoSolicitudBeca == null",
                                  },
                                ],
                                attrs: {
                                  size: "sm",
                                  variant: "outline",
                                  disabled: _vm.readOnly,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.mostrarModalEliminarAlumno(
                                      data.item
                                    )
                                  },
                                },
                              },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "trash", variant: "primary" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("b-pagination", {
                attrs: {
                  "total-rows": _vm.registros,
                  "per-page": _vm.perPage,
                  "aria-controls": "my-table",
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-modal",
                {
                  attrs: { name: "modal-eliminar", size: "md" },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-title",
                      fn: function () {
                        return [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.matriculaGpln.modal.tituloEliminar"
                                )
                              ),
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "modal-footer",
                      fn: function () {
                        return [
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-3",
                              attrs: {
                                variant: "primary",
                                disabled: _vm.readOnly,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.eliminarAlumno()
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.matriculaGpln.acciones.eliminar"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-3",
                              attrs: { variant: "secondary" },
                              on: {
                                click: function ($event) {
                                  _vm.mostrarModalEliminar = false
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.matriculaGpln.acciones.cerrar"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.mostrarModalEliminar,
                    callback: function ($$v) {
                      _vm.mostrarModalEliminar = $$v
                    },
                    expression: "mostrarModalEliminar",
                  },
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "d-block text-center" }, [
                        _c("h3", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "apeironGwApp.matriculaGpln.modal.detalleEliminar"
                              )
                            ),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-modal",
                {
                  attrs: { name: "modal-detalle", scrollable: "", size: "xl" },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-title",
                      fn: function () {
                        return [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.matriculaGpln.modal.tituloDetalle"
                                )
                              ),
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "modal-footer",
                      fn: function () {
                        return [
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-3",
                              attrs: { variant: "secondary" },
                              on: {
                                click: function ($event) {
                                  _vm.mostrarModalDetalle = false
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.matriculaGpln.acciones.cerrar"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.mostrarModalDetalle,
                    callback: function ($$v) {
                      _vm.mostrarModalDetalle = $$v
                    },
                    expression: "mostrarModalDetalle",
                  },
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.matriculaGpln.form.cvuAlumno"
                                ),
                                "label-for": "input-cvu",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-cvu",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.matriculaGpln.form.cvuAlumno"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value:
                                    _vm.alumnoSeleccionado.participante.cvu,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumnoSeleccionado.participante,
                                      "cvu",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alumnoSeleccionado.participante.cvu",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.matriculaGpln.form.curp"
                                ),
                                "label-for": "input-curp",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-curp",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.matriculaGpln.form.curp"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value:
                                    _vm.alumnoSeleccionado.participante.curp,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumnoSeleccionado.participante,
                                      "curp",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alumnoSeleccionado.participante.curp",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.matriculaGpln.form.nombreAlumno"
                                ),
                                "label-for": "input-nombre-alumno",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-nombre-alumno",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.matriculaGpln.form.nombreAlumno"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value:
                                    _vm.alumnoSeleccionado.participante.nombre,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumnoSeleccionado.participante,
                                      "nombre",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alumnoSeleccionado.participante.nombre",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.matriculaGpln.form.apellidoPaterno"
                                ),
                                "label-for": "input-apellido-paterno",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-apellido-paterno",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.matriculaGpln.form.apellidoPaterno"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value:
                                    _vm.alumnoSeleccionado.participante
                                      .apellidoPaterno,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumnoSeleccionado.participante,
                                      "apellidoPaterno",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alumnoSeleccionado.participante.apellidoPaterno",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.matriculaGpln.form.apellidoMaterno"
                                ),
                                "label-for": "input-apellido-materno",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-apellido-materno",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.matriculaGpln.form.apellidoMaterno"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value:
                                    _vm.alumnoSeleccionado.participante
                                      .apellidoMaterno,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumnoSeleccionado.participante,
                                      "apellidoMaterno",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alumnoSeleccionado.participante.apellidoMaterno",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.matriculaGpln.form.tipoBeca"
                                ),
                                "label-for": "input-tipo-beca",
                              },
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  disabled: "",
                                  name: "input-tipo-beca",
                                  options: _vm.tiposBeca,
                                },
                                model: {
                                  value:
                                    _vm.alumnoSeleccionado.participante
                                      .tipoBeca,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumnoSeleccionado.participante,
                                      "tipoBeca",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alumnoSeleccionado.participante.tipoBeca",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.matriculaGpln.form.tiempoDedicacion"
                                ),
                                "label-for": "input-tiempo-dedicacion",
                              },
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  disabled: "",
                                  name: "input-tiempo-dedicacion",
                                  options: _vm.tiemposDedicacion,
                                },
                                model: {
                                  value:
                                    _vm.alumnoSeleccionado.participante
                                      .tiempoDedicacion,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumnoSeleccionado.participante,
                                      "tiempoDedicacion",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alumnoSeleccionado.participante.tiempoDedicacion",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.matriculaGpln.form.promedioAnterior"
                                ),
                                "label-for": "input-promedio-anterior",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-promedio-anterior",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.matriculaGpln.form.promedioAnterior"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value:
                                    _vm.alumnoSeleccionado.participante
                                      .promedioAnterior,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumnoSeleccionado.participante,
                                      "promedioAnterior",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alumnoSeleccionado.participante.promedioAnterior",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.matriculaGpln.form.inicioGeneracion"
                                ),
                                "label-for": "input-inicio-generacion",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-inicio-generacion",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.matriculaGpln.form.inicioGeneracion"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value:
                                    _vm.alumnoSeleccionado.participante
                                      .inicioGeneracion,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumnoSeleccionado.participante,
                                      "inicioGeneracion",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alumnoSeleccionado.participante.inicioGeneracion",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.matriculaGpln.form.duracionMeses"
                                ),
                                "label-for": "input-duracion-meses",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-duracion-meses",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.matriculaGpln.form.duracionMeses"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value:
                                    _vm.alumnoSeleccionado.participante
                                      .duracionMeses,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumnoSeleccionado.participante,
                                      "duracionMeses",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alumnoSeleccionado.participante.duracionMeses",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.matriculaGpln.form.inicioEstudios"
                                ),
                                "label-for": "input-inicio-estudios",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-inicio-estudios",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.matriculaGpln.form.inicioEstudios"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value:
                                    _vm.alumnoSeleccionado.participante
                                      .inicioEstudios,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumnoSeleccionado.participante,
                                      "inicioEstudios",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alumnoSeleccionado.participante.inicioEstudios",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.matriculaGpln.form.finEstudios"
                                ),
                                "label-for": "input-fin-estudios",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-fin-estudios",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.matriculaGpln.form.finEstudios"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value:
                                    _vm.alumnoSeleccionado.participante
                                      .finEstudios,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumnoSeleccionado.participante,
                                      "finEstudios",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alumnoSeleccionado.participante.finEstudios",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.matriculaGpln.form.institucion"
                                ),
                                "label-for": "input-institucion",
                              },
                            },
                            [
                              _c("b-form-select", {
                                staticClass: "resaltar-opciones-disabled",
                                attrs: {
                                  name: "input-institucion",
                                  options: _vm.instituciones,
                                  placeholder: _vm.$t(
                                    "apeironGwApp.matriculaGpln.form.institucion"
                                  ),
                                  disabled: "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "first",
                                    fn: function () {
                                      return [
                                        _c(
                                          "b-form-select-option",
                                          {
                                            attrs: {
                                              value: undefined,
                                              disabled: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.matriculaGpln.form.seleccionarUno"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value:
                                    _vm.alumnoSeleccionado.participante
                                      .institucion,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumnoSeleccionado.participante,
                                      "institucion",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alumnoSeleccionado.participante.institucion",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.matriculaGpln.form.sede"
                                ),
                                "label-for": "input-sede",
                              },
                            },
                            [
                              _c("b-form-select", {
                                staticClass: "resaltar-opciones-disabled",
                                attrs: {
                                  name: "input-sede",
                                  options: _vm.sedes,
                                  placeholder: _vm.$t(
                                    "apeironGwApp.matriculaGpln.form.sede"
                                  ),
                                  disabled: "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "first",
                                    fn: function () {
                                      return [
                                        _c(
                                          "b-form-select-option",
                                          {
                                            attrs: {
                                              value: undefined,
                                              disabled: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.matriculaGpln.form.seleccionarUno"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value:
                                    _vm.alumnoSeleccionado.participante.sede,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.alumnoSeleccionado.participante,
                                      "sede",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alumnoSeleccionado.participante.sede",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "md",
                                label: _vm.$t(
                                  "apeironGwApp.persona.participacion.becario.comprobanteNacionalidad"
                                ),
                                "label-for": "input-comprobante-nacionalidad",
                              },
                            },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    size: "md",
                                    disabled: "",
                                    name: "input-comprobante-nacionalidad",
                                  },
                                  model: {
                                    value:
                                      _vm.alumnoSeleccionado.participante
                                        .comprobanteNacionalidad,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.alumnoSeleccionado.participante,
                                        "comprobanteNacionalidad",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "alumnoSeleccionado.participante.comprobanteNacionalidad",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.persona.participacion.becario.comprobanteNacionalidadDescripcion"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }